<template>
  <div class="app-container comment-detail">
    <basic-container class="comment-detail-container">
      <el-tabs v-model="activeTabName" @tab-click="onTabShow">
        <el-tab-pane label="评论详情" name="detail">
          <div class="comment-detail-tab">
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">内容：</div>
              <div class="comment-detail-item__value">{{ commentDetail.content }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">发布者Full Name：</div>
              <div class="comment-detail-item__value">{{ commentDetail.commentByName || '--' }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">发布者Birth Name：</div>
              <div class="comment-detail-item__value">{{ commentDetail.commentByRealname || '--' }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">评论所在内容：</div>
              <div class="comment-detail-item__value">
                <div class="title">
                  <div class="post-cover-image" v-if="commentDetail.postCoverImg">
                    <img :src="commentDetail.postCoverImg" v-viewer>
                  </div>
                    <a href="javascript:void(0);" @click="goPostDetail(commentDetail.postId);"
                      class="comment-detail-item__link">
                      {{commentDetail.postTitle}}
                    </a>
                </div>
              </div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">点赞：</div>
              <div class="comment-detail-item__value">{{ commentDetail.likeCount || 0 }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">回复对象的评论内容：</div>
              <div class="comment-detail-item__value">{{ commentDetail.commentToContent || '--' }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">回复对象Full Name：</div>
              <div class="comment-detail-item__value">{{ commentDetail.commentToName || '--' }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">回复对象Birth Name：</div>
              <div class="comment-detail-item__value">{{ commentDetail.commentToRealname || '--' }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">回复对象评论时间：</div>
              <div class="comment-detail-item__value">{{ commentDetail.commentToTime }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">状态：</div>
              <div class="comment-detail-item__value">{{ commentDetail.status }}</div>
            </div>
             <div class="comment-detail-item">
              <div class="comment-detail-item__label">下架原因：</div>
              <div class="comment-detail-item__value">{{ commentDetail.banComment }}</div>
            </div>
            <div class="comment-detail-item">
              <div class="comment-detail-item__label">发布时间：</div>
              <div class="comment-detail-item__value">{{ commentDetail.commentTime }}</div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="点赞列表" name="like">
          <avue-crud ref="crud"
            :option="commentLikeTableOption"
            :data="likeTableData"
            :page="likePage"
            :table-loading="likeTableLoading"
            @current-change="handleLikeCurrentChange"
            @refresh-change="handleLikeRefreshChange"
            @size-change="handleLikeSizeChange">
          </avue-crud>
        </el-tab-pane>
        <el-tab-pane label="举报列表" v-if="permissions.complaint_audited_list" name="complaint" class="complaint">
          <el-table :data="postComplaintData" stripe tooltip-effect="dark">
            <el-table-column align="center" prop="reason" label="举报描述" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="complainedBy" label="举报者Full Name" width="140"></el-table-column>
            <el-table-column align="center" prop="complainedByRealname" label="举报者Birth Name" width="140"></el-table-column>
            <el-table-column align="center" prop="label" label="举报分类"></el-table-column>
            <el-table-column align="center" label="举报附件">
              <template slot-scope="scope">
                <a v-if="scope.row.hasAttachment" href="javascript:void(0);" @click="thumbnailDetail(scope.row.handleResult,scope.row.id)" class="list-button">附件详情</a>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="content" label="被举报内容" width="120" show-overflow-tooltip=""></el-table-column>
            <!-- <el-table-column align="center" prop="targetType" label="被举报内容类别"></el-table-column> -->
            <el-table-column align="center" prop="complainedTo" label="被举报者Birth Name" width="160"></el-table-column>
            <el-table-column align="center" prop="complainedToRealname" label="被举报者Full Name" width="160"></el-table-column>
            <el-table-column align="center" prop="complainedTime" label="举报时间" width="160"></el-table-column>
            <el-table-column align="center" prop="handleResult" label="状态"></el-table-column>
          </el-table>
          <el-pagination :page-size="postComplaintPage.pageSize"
                         :page-sizes="postComplaintPage.pageSizes"
                         :current-page="postComplaintPage.currentPage"
                         :total="postComplaintPage.total"
                         :layout="postComplaintPage.layout"
                         @current-change="postComplaintCurrentChange"
                         @size-change="postComplaintSizeChange">
          </el-pagination>
          <el-dialog title="附件详情" :visible.sync="unhandledThumbnailsVisible" width="40%" class="handle-dialog">
            <div v-for="(item, index) in thumbnails" :key="index">
              <img v-if="item" :src="item" class="handle-dialog-img">
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
    <el-dialog
      title=""
      :visible.sync="imgDialogVisible"
      fullscreen
      custom-class="preview-img-dialog">
      <img :src="previewImgUrl" @click="imgDialogVisible = false">
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fetchCommentLikeList, getComment } from '@/api/post/comment';
import { commentLikeTableOption } from '@/const/crud/post/comment';
import postComplaintList from '@/mixins/post/complaint-list';
import { getAttachment } from '@/api/admin/complaints';

export default {
  name: 'comment-detail',
  mixins: [postComplaintList],
  data() {
    return {
      activeTabName: 'detail',
      id: 0,
      targetType: 1, //评论
      commentDetail:{
        id: 0,
        postId: '',
        content: '',
        commentByName: '',
        postTitle: '',
        likeCount: 0,
        postCoverImg: '',
        commentToContent: '',
        commentToName: '',
        commentToRealname: '',
        commentToTime: '',
        status: '',
        commentTime: '',
        banComment: '',
        attachments: []
      },
      attachmentUrls: [],

      likeTabLoaded: false,
      likeTableData:[],
      likePage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条,
      },
      likeTableLoading: false,
      commentLikeTableOption,
      imgDialogVisible: false,
      previewImgUrl: '',
      unhandledThumbnailsVisible: false,
      thumbnails: undefined,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getDetail()
  },
  watch: {
    $route () {
      this.id = this.$route.params.id;
      this.getDetail()
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    onTabShow(tab) {
      if (tab.name === 'like') {
        this.initLikeTab();
      } else if (tab.name === 'complaint') {
        this.initPostComplaint();
      }
    },
    getDetail() {
      getComment(this.id).then(response => {
        let data = response.data
        if (data.code === 0) {
          this.commentDetail = this.formatCommentDetail(data.data);
          this.commentDetail.attachments.forEach((item) => {
            this.attachmentUrls.push(item.attachmentUrl)
          })
        } else {
          this.$message({
            showClose: true,
            message: '获取数据失败',
            type: 'error'
          });
        }
      }).catch(function () {
        this.$message({
          showClose: true,
          message: '获取数据失败',
          type: 'error'
        });
      });
    },
    formatCommentDetail(data) {
      let commentDetail = {};
      commentDetail.id = data.id;
      commentDetail.postId = data.postId;
      commentDetail.banComment = data.banComment;
      commentDetail.content = data.content;

      if (!data.commentBy) {
        commentDetail.commentByName = '--';
        commentDetail.commentByRealname = '--';
      } else {
        commentDetail.commentByName = data.commentBy.name || '--';
        commentDetail.commentByRealname = data.commentBy.memberType === 1
          ? data.commentBy.relatedPersonalRealname
          : data.commentBy.realname;
        
      }
      if (!data.commentTo) {
        commentDetail.commentToName = '--';
        commentDetail.commentToRealname = '--';
      } else {
        commentDetail.commentToName = data.commentTo.name || '--';
        commentDetail.commentToRealname = data.commentTo.realname;
      }

      commentDetail.postTitle = data.postTitle || '--';
      commentDetail.postCoverImg = data.postCoverImg;
      commentDetail.commentToContent = data.commentToContent || '--';
      commentDetail.commentToTime = data.commentToTime || '--';

      if (data.isActive === 1 ) {
        commentDetail.status = '评论已删除';
      } else if (data.isBanned === 0) {
        commentDetail.status = '已上架';
      } else if (data.isBanned === 1) {
        commentDetail.status = '已下架';
      } else {
        commentDetail.status = '--';
      }

      commentDetail.commentTime = data.commentTime;
      commentDetail.likeCount = data.likeCount;
      commentDetail.attachments = data.attachments;
      return commentDetail
    },
    initLikeTab() {
      if (this.likeTabLoaded) {
        return;
      }

      this.getLikeList();
    },
    getLikeList() {
      let params = {
        commentId: this.id,
        current: this.likePage.currentPage,
        size: this.likePage.pageSize,
      };

      this.likeTableLoading = true
      fetchCommentLikeList(params).then(response => {
        if (response.data.code === 0) {
          this.likeTableData = response.data.data.records;
          this.likeTableData.forEach(like => {
            like.realname = like.memberType===1
              ? like.relatedPersonalRealname
              : like.realname;
          });
          this.likePage.total = response.data.data.total;
        } else {
          this.likeTableData = [];
          this.likePage.total = 0;
        }
        this.likeTableLoading = false;
      });
      this.likeTabLoaded = true;
    },
    goPostDetail(postId){
      this.$router.push({
        path: `/content/list/detail/${postId}`
      })
    },
    thumbnailDetail(handleResult, id) {
      this.unhandledThumbnailsVisible = handleResult !== 0
      getAttachment(id).then(response => {
        this.thumbnails = response.data.data
      })
    },
    handleLikeCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleLikeRefreshChange() {
      this.getList();
    },
    handleLikeSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    previewImg(url) {
      this.previewImgUrl = url;
      this.imgDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-detail-tab {
  width: 100%;

  .comment-detail-item {
    padding-top: 10px;
    padding-bottom: 10px;

    &__label {
      display: inline-block;
      width: 200px;
    }
    &__value {
      display: inline-block;
    }

    &__link {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
    }
  }
}
.title {
  display: flex;
  align-items: center;
  .post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
.complaint {
  .list-button {
    color: #409EFF;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
  }
  .handle-dialog {
    &-img {
      max-width: 100%;
    }
  }
}
</style>
